import { useState } from 'react';

const useValidation = () => {
  const [validationErrors, setValidationErrors] = useState({});

  const setFocus = (errorObj) => {
    // always focus on first element
    const keysArray = Object.keys(errorObj);
    if (keysArray.length > 0) {
      // default array sort is string based. Giving func here.
      keysArray.sort((a, b) => a - b);
      /* eslint-disable unicorn/prefer-query-selector -- need */
      const ele = document.getElementById(`${errorObj[keysArray[0]]}`);
      /* eslint-enable unicorn/prefer-query-selector -- need */
      if (ele) {
        ele.focus();
        return true;
      }
    }
    return false;
  };

  return { validationErrors, setValidationErrors, setFocus };
};

export default useValidation;
